import React, { useEffect, useRef } from 'react';
import { MapContainer, Marker, TileLayer, ZoomControl } from 'react-leaflet';
import { useMap, useMapEvents } from 'react-leaflet/hooks';
import 'leaflet/dist/leaflet.css';
import { homeIcon } from '../../listing-detail/components/location-section';

const ZOOM = 13;
// the standard OpenStreetMap tiles, because they print the building numbers when zoomed in
const TILES = 'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png';
const MAX_ZOOM = 19;

const Focus = ({ center, zoom }) => {
    const map = useMap();
    const first = useRef(true);

    // the form above the map can still be settling when the map is first drawn
    useEffect(() => {
        const timer = setTimeout(() => map.invalidateSize(), 500);
        return () => clearTimeout(timer);
    }, [map]);

    useEffect(() => {
        if (first.current) {
            first.current = false;
            return;
        }
        map.flyTo(center, zoom);
    }, [center, zoom, map]);

    return null;
};

const ClickToMark = ({ onPick }) => {
    useMapEvents({ click: (e) => onPick([e.latlng.lat, e.latlng.lng]) });
    return null;
};

// a click puts the pin there, the same pin as on the listing page. position is null until one is marked
export const LocationPicker = ({ position, focus, focusZoom, onPick }) => (
    <MapContainer center={focus} zoom={ZOOM} maxZoom={MAX_ZOOM} zoomControl={false} scrollWheelZoom={false}>
        <TileLayer url={TILES} maxZoom={MAX_ZOOM} attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a>' />
        <ZoomControl position='topright' />
        {position && <Marker position={position} icon={homeIcon} interactive={false} />}
        <Focus center={focus} zoom={focusZoom} />
        <ClickToMark onPick={onPick} />
    </MapContainer>
);
